import $ from "jquery";
import moment from "moment";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

let params;

function init() {
    let scheduledCourseDayNumber = -1;

    $(document).on("click", ".selectAllCheckbox", function() {
        const id = this.id;
        $("input[name='checkbox_" + id + "']").prop("checked", this.checked);
    });

    $(document).on("click", "#printSchedule", function() {
        const courseId = $("#courseId").val();
        const url = `/Course/CourseSchedulePdf?courseId=${courseId}`;
        forms.openPrintWindow(url);
    });

    $(document).on("click", ".editbtn", function() {
        const row = $(this).closest("tr");
        $(row).find("div.editRow").each(function(column, div) {
            $(div).removeClass("hidden");
        });
        $(row).find("div.viewRow").each(function(column, div) {
            $(div).addClass("hidden");
        });
    });

    $(document).on("click", ".saveBtn", function() {
        const row = $(this).closest("tr");
        const description = row.find("#taskDescription");
        const instructor = row.find("#instructorSelect");
        const startTime = row.find("#courseScheduleStart");
        const endTime = row.find("#courseScheduleEnd");
        if (startTime && startTime.length > 0 && endTime && endTime.length > 0)
            row.find("#scheduleTime").text(startTime[0].value + " - " + endTime[0].value);
        if (description && description.length > 0)
            row.find("#viewDescription").text(description[0].value);
        if (instructor && instructor.length > 0 && instructor[0].selectedOptions && instructor[0].selectedOptions.length > 0)
            row.find("#viewInstructor").text(instructor[0].selectedOptions[0].text);
        const data = {
            courseScheduleId: row.attr("courseScheduleId"),
            description: (description && description.length > 0 ? description[0].value : ""),
            instructorId: (instructor && instructor.length > 0 ? instructor[0].value : ""),
            startTime: (startTime && startTime.length > 0 ? startTime[0].value : ""),
            endTime: (endTime && endTime.length > 0 ? endTime[0].value : "")
        };
        params = {
            "url": "/Course/EditCourseSchedule",
            "data": data
        };
        dataaccess.post(params).done(function(data) {
            $(row).find("div.viewRow").each(function(column, div) {
                $(div).removeClass("hidden");
            });
            $(row).find("div.editRow").each(function(column, div) {
                $(div).addClass("hidden");
            });
            services.notificationService.success("Successfully updated Course Schedule.");
        });
    });

    $(document).on("click", ".cancelBtn", function() {
        const row = $(this).closest("tr");
        $(row).find("div.viewRow").each(function(column, div) {
            $(div).removeClass("hidden");
        });
        $(row).find("div.editRow").each(function(column, div) {
            $(div).addClass("hidden");
        });
    });

    $(document).on("click", ".deleteSchedule", function(e) {
        deleteScheduleRow();
    });

    $(document).on("click", ".addSchedule", function(e) {
        scheduledCourseDayNumber = this.id;
        $("input.form-control").val("");
        $("#txtDay").val(this.id);
        $("#txtCourseDate").val($(this).attr("courseDate"));
        $("#txtCourseId").val($("#courseId").val());
    });

    $(document).on("click", "#addSchedulebtn", function(e) {
        let startHour = 0;
        let startMinutes = 0;
        let endHour = 0;
        let endMinutes = 0;
        const courseDate = new Date($("#txtCourseDate").val());
        if (($("#StartTime") !== null && $("#StartTime").val().length > 0) ||
            ($("#EndTime") !== null && $("#EndTime").val().length > 0)) {
            startHour = moment(new Date($("#StartTime").val()), ["h:mm A"]).format("HH");
            startMinutes = moment(new Date($("#StartTime").val()), ["h:mm A"]).format("mm");
            endHour = moment(new Date($("#EndTime").val()), ["h:mm A"]).format("HH");
            endMinutes = moment(new Date($("#EndTime").val()), ["h:mm A"]).format("mm");
        }
        const startDateTime = new Date(courseDate.getFullYear(), courseDate.getHours(), courseDate.getMinutes(), startHour, startMinutes);
        const endDateTime = new Date(courseDate.getFullYear(), courseDate.getHours(), courseDate.getMinutes(), endHour, endMinutes);
        if (startDateTime > endDateTime) {
            services.notificationService.error(
                " Course 'end' date time cannot be before course 'start' date time. Please enter valid 'end date'.");
            return false;
        }
        const $container = $("#schedule");
        $("#addCourseScheduleModal .close").click();

        const params = {
            "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            "data": $("#AddScheduleForm").serialize(),
            "url": "/Course/AddCourseSchedule", // it's the URL of your component B
            "successMsg": "Successfully added to the Course Schedule."
        };

        dataaccess.post(params).done(function(result) {
            $container.html(result);
            openAccordionPanel(scheduledCourseDayNumber - 1);
        });
    });
}

function openAccordionPanel(accordianNumber) {
    $("div#collapse_" + accordianNumber).collapse("show");
}

function deleteScheduleRow() {
    let courseScheduleIds = [];

    $("[courseScheduleId]:checked").each(function() {
        courseScheduleIds.push($(this).attr("courseScheduleId"));
        $(this).remove();
    });

    courseScheduleIds = jQuery.grep(courseScheduleIds, function(n, i) {
        return (n !== "" && n != null);
    });

    if (courseScheduleIds.length > 0) {
        const params = {
            "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            "data": { "courseScheduleIds": courseScheduleIds },
            "url": "/Course/DeleteCourseSchedules",
            "successMsg": "Successfully deleted from Course Schedule."
        };

        dataaccess.post(params).done(function() {
            for (let i = 0; i < courseScheduleIds.length; i++) {
                $("#courseScheduleTable [courseScheduleId=" + courseScheduleIds[i] + "]").remove();
            }
        });
    }
}

export const courseSchedule = {
    init: init
};